/** Derive open / full date sets from availability rows for one doctor. */
export function dateAvailabilitySets(doctorDays = []) {
  const datesWithSlots = new Set();
  const datesFullyBooked = new Set();
  doctorDays.forEach((a) => {
    const grid = a.slot_grid || [];
    const hasOpenGrid = grid.some((s) => s.available);
    const hasOpenLegacy = (a.slots || []).length > 0;
    const dailyOpen = a.booking_mode === 'daily_count' && (a.remaining || 0) > 0;
    if (hasOpenGrid || hasOpenLegacy || dailyOpen) datesWithSlots.add(a.date);
    if ((grid.length && !hasOpenGrid) || (a.booking_mode === 'daily_count' && (a.remaining || 0) <= 0)) {
      datesFullyBooked.add(a.date);
    }
  });
  return { datesWithSlots, datesFullyBooked };
}

export function mergeSlotGrid(dayRows = []) {
  const map = new Map();
  dayRows.forEach((r) => {
    (r.slot_grid || []).forEach((s) => {
      const prev = map.get(s.time);
      // Prefer unavailable (booked/full) so taken times never look open.
      if (!prev || (prev.available && !s.available)) map.set(s.time, s);
    });
  });
  if (!map.size) return null;
  return Array.from(map.values()).sort((a, b) => a.time.localeCompare(b.time));
}
